export class Reportdata {

    id: number;
    title: string;
    report: boolean;
    searchPath: string;
    


    constructor(id: number, title: string, report: boolean, searchPath: string) {
        this.id = id;
        this.title = title;
        this.report = report;
        this.searchPath = searchPath;
    }
}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/model/reportdata.ts